const ShieldIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.3148 6.88987L31.5789 6.64062L7.99524 30.2384L8.70308 31.1128C10.8144 33.721 13.5864 35.8125 16.9904 37.1882L17.048 37.2115C18.0703 37.6248 18.7926 37.9168 20.0028 37.9168C21.2129 37.9168 21.9352 37.6248 22.9574 37.2115L23.015 37.1882C33.4922 32.9537 37.7303 22.1152 35.7926 10.7286L35.7804 10.6569C35.6999 10.1858 35.6254 9.74973 35.5284 9.3908C35.4223 8.99881 35.262 8.58526 34.9448 8.21329C34.618 7.82994 34.1741 7.60066 33.8008 7.43716C33.4055 7.26403 32.9013 7.08853 32.3148 6.88987Z"
        fill="#0051FF"
      />
      <path
        opacity="0.4"
        d="M32.3144 6.88941C32.1745 6.84203 32.027 6.7924 31.8729 6.74052L31.8713 6.73997C30.6785 6.33846 29.5949 5.70786 28.3627 4.99075C27.8559 4.69585 27.3241 4.38632 26.7491 4.07207C24.8631 3.04127 22.6835 2.08301 19.9971 2.08301C17.3108 2.08301 15.1321 3.04125 13.247 4.07209C12.6722 4.38643 12.1405 4.69604 11.634 4.99099C10.403 5.70781 9.31969 6.3384 8.12791 6.7399L8.08478 6.75442C7.38114 6.99139 6.79269 7.18956 6.34578 7.37442C5.92273 7.54941 5.41376 7.7921 5.05481 8.21319C4.73774 8.58516 4.57742 8.99867 4.47144 9.39063C4.37439 9.74956 4.29995 10.1855 4.21953 10.6566L4.21108 10.7061C2.90266 18.3658 4.37542 25.767 8.70265 31.1124L9.57655 32.1919L34.2191 7.53453L32.3144 6.88941Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default ShieldIcon;
